import { Box, Typography, Grid, InputLabel, useTheme, TextField, RadioGroup, FormControlLabel, Radio, Button, Select, MenuItem, InputAdornment, IconButton, Alert } from "@mui/material"
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import { useScheduled } from '../../../../shared/context/scheduledContext'
import { useUtiles } from '../../../../shared/context/utilesContext'
import TypeTaskComponent from '../TypeTaskComponent'
import { useForm, Controller } from "react-hook-form"
import ClearIcon from '@mui/icons-material/Clear'
import ClassificationComponent from '../ClassificationComponent'
import { useEffect } from "react"
import SaveIcon from '@mui/icons-material/Save'
import { useParams } from "react-router"
export default function CreateTaskComponent({ readOnly }) {
    const theme = useTheme()
    const { setStepActive, taskScheduled, setTaskScheduled, setSelectTypeTask, setSelectClassification, subtaskScheduledList, createTask, updateTask } = useScheduled()
    const { priorityOptions, openSilderWith, saveCurrentComponent, generateRandomCode } = useUtiles()

    const { control, handleSubmit, formState: { errors }, setValue } = useForm()

    const { code_group } = useParams()

    useEffect(() => {
        console.log('subtaskScheduledList', subtaskScheduledList)
        //solo al iniciar el componente cambiar el codigo de la primera subtarea
        if (subtaskScheduledList.length > 0 && !subtaskScheduledList[0].code) {
            subtaskScheduledList[0].code = generateRandomCode()
        }
    }, [])



    const handleAddSubtasks = () => {
        setStepActive(2)
    }

    const handleOpenSelectTypeTask = () => {
        openSilderWith(<TypeTaskComponent functionSelect={setSelectTypeTask} />, 700, 'Seleccionar tipo de tarea')
        saveCurrentComponent()
    }



    const handleOpenSelectClassification = (number) => {
        openSilderWith(<ClassificationComponent number={number} functionSelect={setSelectClassification} />, 700, 'Seleccionar clasificación')
        saveCurrentComponent()
    }


    useEffect(() => {
        if (taskScheduled.priority) {
            setTaskScheduled({ ...taskScheduled, time_duration: priorityOptions.find(option => option.value === taskScheduled.priority)?.time_estimate || '00:00' })
        }
    }, [taskScheduled.priority])


    useEffect(() => {
        if (code_group) {
            setTaskScheduled({ ...taskScheduled, group_scheduled_hash: code_group })
        }
    }, [code_group])



    const handleCreateTask = () => {
        if (taskScheduled.hash_code) {
            updateTask()
        } else {
            createTask()
        }
    }


    return (
        <Box sx={{
            padding: '5px',
        }}>
            <Grid container spacing={2}>
                {
                    taskScheduled.assigned_to_ot && (
                        <Grid item size={{ xs: 12 }}>
                            <Alert severity="warning">La tarea ya esta asignada a una OT, no se puede editar</Alert>
                        </Grid>
                    )
                }
                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Descripción de la tarea</InputLabel>
                    <Controller
                        control={control}
                        name="description"
                        rules={{ required: 'Este campo es requerido' }}
                        render={({ field }) => (
                            <TextField fullWidth placeholder="Descripción de la tarea"
                                error={!taskScheduled.description} helperText={!taskScheduled.description ? 'La descripción es requerida' : ''}
                                value={taskScheduled.description || ''}
                                onChange={(e) => setTaskScheduled({ ...taskScheduled, description: e.target.value })}
                                slotProps={{
                                    input: {
                                        readOnly: taskScheduled.assigned_to_ot || readOnly,
                                    }
                                }}

                            />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Nota:</InputLabel>
                    <Controller
                        control={control}
                        name="note"
                        render={({ field }) => (
                            <TextField fullWidth placeholder="Nota"
                                rows={2}
                                multiline
                                value={taskScheduled.note || ''}
                                onChange={(e) => setTaskScheduled({ ...taskScheduled, note: e.target.value })}
                                slotProps={{
                                    input: {
                                        readOnly: taskScheduled.assigned_to_ot || readOnly,
                                    }
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Tipo de tarea</InputLabel>
                    <Controller
                        control={control}
                        name="typeTask"
                        rules={{ required: 'Este campo es requerido' }}
                        render={({ field }) => (
                            <TextField fullWidth placeholder="Tipo de tarea" onClick={() => { taskScheduled.assigned_to_ot || readOnly ? null : handleOpenSelectTypeTask() }}
                                error={!taskScheduled.typeTask} helperText={!taskScheduled.typeTask ? 'El tipo de tarea es requerido' : ''}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                        endAdornment: taskScheduled.typeTask && !taskScheduled.assigned_to_ot && !readOnly && (
                                            <InputAdornment position="end">
                                                <IconButton onClick={(e) => {
                                                    e.stopPropagation();
                                                    setTaskScheduled({ ...taskScheduled, typeTask: null })
                                                }}>
                                                    <ClearIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }
                                }}
                                value={taskScheduled.typeTask?.value || ''} />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Clasificación 1</InputLabel>
                    <Controller
                        control={control}
                        name="classification_1"
                        render={({ field }) => (
                            <TextField fullWidth placeholder="Clasificación 1" onClick={() => taskScheduled.assigned_to_ot || readOnly ? null : handleOpenSelectClassification(1)}
                                value={taskScheduled.classification_1?.value || ''}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                        endAdornment: taskScheduled.classification_1 && !taskScheduled.assigned_to_ot && !readOnly && (
                                            <InputAdornment position="end">
                                                <IconButton onClick={(e) => {
                                                    e.stopPropagation();
                                                    setTaskScheduled({ ...taskScheduled, classification_1: null })
                                                }}>
                                                    <ClearIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Clasificación 2</InputLabel>
                    <Controller
                        control={control}
                        name="classification_2"
                        render={({ field }) => (
                            <TextField fullWidth placeholder="Clasificación 2" onClick={() => taskScheduled.assigned_to_ot || readOnly ? null : handleOpenSelectClassification(2)}
                                value={taskScheduled.classification_2?.value || ''}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                        endAdornment: taskScheduled.classification_2 && !taskScheduled.assigned_to_ot && !readOnly && (
                                            <InputAdornment position="end">
                                                <IconButton onClick={(e) => {
                                                    e.stopPropagation();
                                                    setTaskScheduled({ ...taskScheduled, classification_2: null })
                                                }}>
                                                    <ClearIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Prioridad</InputLabel>
                    <Select
                        fullWidth
                        variant="outlined"
                        placeholder="Seleccione la prioridad de la tarea"
                        value={taskScheduled.priority || ''}
                        onChange={(e) => setTaskScheduled({ ...taskScheduled, priority: e.target.value })}
                        slotProps={{
                            input: {
                                readOnly: taskScheduled.assigned_to_ot || readOnly,
                            }
                        }}
                    >
                        {priorityOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.icon}
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid item size={{ xs: 12, lg: 6 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Tiempo de estimado de ejecución</InputLabel>
                    <TextField slotProps={{ input: { readOnly: true } }} fullWidth placeholder="Tiempo de estimado de ejecución" value={priorityOptions.find(option => option.value === taskScheduled.priority)?.time_estimate || '00:00'} />
                </Grid>
                <Grid item size={{ xs: 12, lg: 6 }}>
                    <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary, fontSize: '14px' }}>Requiere documento SSOMA</InputLabel>
                    <Controller
                        control={control}
                        name="required_ssoma_document"
                        render={({ field }) => (
                            <RadioGroup slotProps={{ input: { readOnly: taskScheduled.assigned_to_ot || readOnly } }} row value={taskScheduled.required_ssoma_document} onChange={(e) => setTaskScheduled({ ...taskScheduled, required_ssoma_document: e.target.value })}>
                                <FormControlLabel disabled={taskScheduled.assigned_to_ot || readOnly} value="SI" control={<Radio />} label="SI" />
                                <FormControlLabel disabled={taskScheduled.assigned_to_ot || readOnly} value="NO" control={<Radio />} label="NO" />
                            </RadioGroup>
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12 }}>
                    <Button variant="contained" color="primary" startIcon={<KeyboardDoubleArrowRightOutlinedIcon />} onClick={handleAddSubtasks}>{ !taskScheduled.assigned_to_ot && !readOnly ? 'Agregar subtareas' : 'Ver subtareas'}</Button>
                    {!taskScheduled.assigned_to_ot && !readOnly && <Button disabled={subtaskScheduledList.length === 0 || taskScheduled.assigned_to_ot || readOnly} variant="contained" color="primary" sx={{ marginLeft: '10px' }} onClick={handleCreateTask} startIcon={<SaveIcon />}> {taskScheduled.hash_code ? 'Actualizar' : 'Crear'}</Button>
                    }                
                    </Grid>

            </Grid>
        </Box>
    )
}